<template>
  <vs-dropdown vs-custom-content vs-trigger-click class="cursor-pointer">
    <span class="cursor-pointer flex items-center i18n-locale">
      <img class="h-4 w-5" :src="i18n_locale_img" :alt="$i18n.locale" />
      <span class="hidden sm:block ml-2">
        {{ $t(`LOCALES.${getCurrentLocaleData.lang.toLowerCase()}`) }}
      </span>
    </span>
    <vs-dropdown-menu class="w-48 i18n-dropdown vx-navbar-dropdown">
      <vs-dropdown-item v-for="(flag, index) in flags" :key="index" @click="updateLocale(flag.language)">
        <img class="h-4 w-5 mr-1" :src="require(`@/assets/images/flags/${flag.imgFlag}`)" :alt="flag.language" />
        &nbsp;{{ $t(`LOCALES.${flag.t}`) }}
      </vs-dropdown-item>
    </vs-dropdown-menu>
  </vs-dropdown>
</template>

<script>
export default {
  data() {
    return {
      flags: [
        // {
        //   language: "es",
        //   imgFlag: "es.png",
        //   t: "spanish"
        // },
        {
          language: "en",
          imgFlag: "en.png",
          t: "english"
        },
        {
          language: "pt",
          imgFlag: "pt.png",
          t: "portugués"
        }
      ]
    };
  },
  computed: {
    i18n_locale_img() {
      // Use below code to dynamically fetch image instead of if-else
      // NOTE: We used if-else because laravel throws error in 'yarn prod'.
      // If you are not using laravel + Vue, you can use below code to dynamically get image
      // return require(`@/assets/images/flags/${this.$i18n.locale}.png`)

      const locale = this.$i18n.locale;
      if (locale === "en") return require("@/assets/images/flags/en.png");
      else if (locale === "pt") return require("@/assets/images/flags/pt.png");
      else if (locale === "fr") return require("@/assets/images/flags/fr.png");
      else if (locale === "de") return require("@/assets/images/flags/de.png");
      else if (locale === "es") return require("@/assets/images/flags/es.png");
      else return require("@/assets/images/flags/en.png");
    },
    getCurrentLocaleData() {
      const locale = this.$i18n.locale;
      if (locale === "en") return { flag: "us", lang: "english" };
      else if (locale === "pt") return { flag: "pt", lang: "portugués" };
      else if (locale === "fr") return { flag: "fr", lang: "French" };
      else if (locale === "de") return { flag: "de", lang: "German" };
      else if (locale === "es") return { flag: "es", lang: "spanish" };
    }
  },
  methods: {
    updateLocale(locale) {
      this.$i18n.locale = locale;
    }
  }
};
</script>
